var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExamTimeTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_twotone_menu-board",
    "data-name": "vuesax/twotone/menu-board",
    transform: "translate(-172 -380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-board"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.933,2.8l-3.37,13.53a2.228,2.228,0,0,1-2.18,1.71H2.243A2.257,2.257,0,0,1,.1,15.11L4.313,1.59A2.251,2.251,0,0,1,6.453,0h12.3a2.232,2.232,0,0,1,2.07,1.38A2.208,2.208,0,0,1,20.933,2.8Z",
    transform: "translate(172.997 383.96)",
    fill: "none",
    stroke: "#2f468c",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,16H4.78a2.216,2.216,0,0,0,2.21-2.38L6,0",
    transform: "translate(188 386)",
    fill: "none",
    stroke: "#f4347f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,4.32,1.04,0",
    transform: "translate(181.68 382.06)",
    fill: "none",
    stroke: "#2f468c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,4.34.94,0",
    transform: "translate(188.38 382.05)",
    fill: "none",
    stroke: "#2f468c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H8",
    transform: "translate(179.7 392)",
    fill: "none",
    stroke: "#f4347f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H8",
    transform: "translate(178.7 396)",
    fill: "none",
    stroke: "#f4347f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(172 380)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamTimeTable);
export default __webpack_public_path__ + "static/media/examTimeTable.9340b3d071aa34f892421770d34f6a26.svg";
export { ForwardRef as ReactComponent };